<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ExtractList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import ExtractList from '@/components/extract/ExtractList'

export default {
  name: 'Os',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ExtractList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addextract' })
    }
  }
}
</script>
